import React, { useState } from 'react';
import PropTypes from 'prop-types';
import history from 'routing/history';
import { getMobileAppLink } from 'helpers';
import { Logo, ProductNavbar, Caret, Dropdown, AppButton } from './styled';
import Menu from './Menu';

const MobileNavigation = ({ isProductNavOpen, ...restProps }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navigateToHome = () => {
    setIsOpen(false);
    history.push('/nomad-insurance');
  };

  const toggleNav = () => {
    setIsOpen(!isOpen);
    isProductNavOpen(!isOpen);
  };

  const closeNav = () => {
    setIsOpen(false);
    isProductNavOpen(false);
  };

  return (
    <ProductNavbar isOpen={isOpen} {...restProps}>
      <Logo onClick={navigateToHome} />
      {!isOpen && (
        <AppButton
          color="confetti"
          onClick={() => window.open(getMobileAppLink(), '_blank', 'noopener noreferrer')}
        >
          Use app
        </AppButton>
      )}
      <Dropdown onClick={toggleNav}>
        <Caret $isOpen={isOpen} />
      </Dropdown>
      <Menu isOpen={isOpen} onClose={closeNav} />
    </ProductNavbar>
  );
};

MobileNavigation.propTypes = {
  isProductNavOpen: PropTypes.func
};

export default MobileNavigation;
